import styled from "@emotion/styled";
import { child, get, getDatabase, ref, set } from "firebase/database";
import { useEffect, useRef, useState } from "react";

import { fireBaseApp } from "../db/db";
import { setTodayVisitCount, setVisitorCount } from "../utils/utils";

const SideBarContainer = styled.div`
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  padding: 20px;

  background-color: white;
  z-index: 9999;

  @media (max-width: 768px) {
    bottom: 0;
    top: unset;
    transform: unset;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.1);
    height: 50px;
  }
`;

const useAudio = (url: string) => {
  const [audio] = useState(new Audio(url));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [playing]);

  useEffect(() => {
    audio.addEventListener("ended", () => setPlaying(false));
    return () => {
      audio.removeEventListener("ended", () => setPlaying(false));
    };
  }, []);

  return [playing, toggle];
};

const getVisitorCount = async () => {
  const yearMonthDate = new Date().toISOString().slice(2, 10).replace(/-/g, "");
  // console.log(yearMonthDate);
  const snapshotToday = await get(
    child(ref(getDatabase(fireBaseApp)), `visit/${yearMonthDate}/count`)
  );
  const snapshotTotal = await get(
    child(ref(getDatabase(fireBaseApp)), `visit/total`)
  );
  const todayCount = snapshotToday.val();
  const totalCount = snapshotTotal.val();
  return [todayCount, totalCount];
};

const incrementVisitorCount = async () => {
  const yearMonthDate = new Date().toISOString().slice(2, 10).replace(/-/g, "");
  const snapshotToday = await get(
    child(ref(getDatabase(fireBaseApp)), `visit/${yearMonthDate}/count`)
  );
  const snapshotTotal = await get(
    child(ref(getDatabase(fireBaseApp)), `visit/total`)
  );
  const todayCount = snapshotToday.val();
  const totalCount = snapshotTotal.val();

  // set(
  //   ref(getDatabase(fireBaseApp), `visit/${yearMonthDate}/count`),
  //   todayCount + 1
  // );
  // set(ref(getDatabase(fireBaseApp), `visit/total`), totalCount + 1);

  setTodayVisitCount(todayCount + 1, yearMonthDate);
  setVisitorCount(totalCount+1);
};

const DayContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
  }
`;

const CounterContainer = styled.div`
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    width: 150px;
    border-right: 1px solid #eaeaea;
  }
`;

const Visitors = () => {
  const [todayCount, setTodayCount] = useState(0);
  const [totalCount, setTotal] = useState(0);

  const updateCounter = async () => {
    const [todayCount, totalCount] = await getVisitorCount();
    setTodayCount(todayCount);
    setTotal(totalCount);
  };

  useEffect(() => {
    updateCounter();
    incrementVisitorCount();
  }, []);

  return (
    <CounterContainer>
      <DayContainer>
        오늘 <div>{todayCount}</div>
      </DayContainer>
      ﹒
      <DayContainer>
        전체 <div>{totalCount}</div>
      </DayContainer>
    </CounterContainer>
  );
};

const ShareContainer = styled.div`
  margin-top: 10px;
  cursor: pointer;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 0;
    width: 80px;
  }
`;

const Share = () => {
  const copyUrl = async () => {
    await navigator.clipboard.writeText(window.location.href);
    alert("URL이 복사되었습니다.");
  };

  return (
    <ShareContainer onClick={copyUrl}>
      <img src="/ios_share.svg" alt="share" width={20} height={20} />
    </ShareContainer>
  );
};

const MusicContainer = styled.div`
  @media (max-width: 768px) {
    width: 80px;
    border-right: 1px solid #eaeaea;
  }
`;

const Music = () => {
  const [playing, toggle] = useAudio("/sound/buddy.mp3");
  return (
    <MusicContainer
      onClick={() => {
        if (toggle !== true && toggle !== false) {
          toggle();
        }
      }}
      style={{ cursor: "pointer" }}
    >
      <img
        src={`${playing ? "/music_note.svg" : "/music_off.svg"}`}
        alt="sound"
        width={20}
        height={20}
      />
    </MusicContainer>
  );
};

const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  margin: 20px 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export function SideBar({ show }: { show: boolean }) {
  return (
    <>
      {show && (
        <SideBarContainer>
          <Visitors />
          <HorizontalLine />
          <Music />
          <Share />
        </SideBarContainer>
      )}
    </>
  );
}
